import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Spinner } from "react-bootstrap";
import { Building, Calendar2, Cash, HddNetwork, LockFill, Map, Person, Phone, PinMap, TextParagraph } from "react-bootstrap-icons";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

export default function RetraitInfos({ coderetrait }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [starting, setstarting] = useState(false);
    const [cancelling, setcancelling] = useState(false);
    const [doing, setdoing] = useState(false);
    const [rejecting, setrejecting] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [validstate, setvalidstate] = useState(false);
    const [error, setError] = useState(false);

    const [nom, setnom] = useState("");
    const [numtel, setnumtel] = useState("");
    const [montant, setmontant] = useState("");
    const [montantmax, setmontantmax] = useState("");
    const [motif, setmotif] = useState("");
    const [revendeur, setrevendeur] = useState('');
    const [revendeursList, setrevendeursList] = useState([]);

    const [datecrea, setDatecrea] = useState("");
    const [etatdef, setetatdef] = useState("");
    const [etat, setEtat] = useState(0);


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    const getRevendeur = async () => {

        if (user?.isRevendeur) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            myHeaders.append("token", config.secure.PUBLICKEY);
            myHeaders.append("apikey", user.token);
            myHeaders.append("cpte", user.code);
            myHeaders.append("prof", user.profil);
            myHeaders.append("conn", user.espace);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                // body: urlencoded,
                redirect: 'follow'
            };

            // console.log("data send", urlencoded)

            await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users/${user?.codeutilisateur}?type=revendeur`, requestOptions).then((response) => {
                if (response?.status === 200) {
                    response.json().then(async (data) => {
                        // console.log("resonse jsondecode", data);
                        if (data?.head) {
                            let body = data?.body?.data[0];


                            // setmontant(Number.parseInt(body?.solde));
                            setmontantmax(Number.parseInt(body?.solde));
                        } else {
                            if (data?.body?.data?.msg === "expiredsession") {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // console.log("server error", err);
                            }
                        }
                    });
                } else if (response?.status === 401) {
                    logoutUser();
                    navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                } else {
                    // console.log("statut error", err);
                }

            }).catch((err) => {
                console.log("error get reventeurs list", err);
                // setError(true);
                // setLoading(false);
            });
        }
    }

    const getElement = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.app.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: "GET",
            headers: myHeaders,
            // body: urlencoded,
            redirect: "follow",
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/withdrawalrequests/${coderetrait}?page=0`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data?.body?.data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setmotif(body?.motif !== null ? body?.motif : "");
                        setnom(body?.nom !== null ? body?.nom : "");
                        setnumtel(body?.numtel !== null ? body?.numtel : "");
                        setmontant(body?.montant !== null ? Number.parseInt(body?.montant) : "");

                        setrevendeur(
                            body?.codecompterevendeur ? { label: body?.nomuser + " " + body?.prenom, value: body?.codecompterevendeur, } : ""
                        );
                        setetatdef(body?.etatdef !== null ? body?.etatdef : 0);
                        setEtat(body?.etat !== null ? body?.etat : 0);

                        // setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 10) : "");
                        setDatecrea(
                            body?.datecrea !== null
                                ? body?.datecrea.slice(0, 16).replace("T", " à ")
                                : ""
                        );

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    };

    // comportements
    useEffect(() => {
        getElement();
        getRevendeur();
    }, []);

    const handleDelete = async () => {
        confirmAlert({
            title: textes.fr.deletedmretratilabel,
            message: textes.fr.deletedmretratilabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: "#01203f",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        setDeleting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var requestOptions = {
                            method: "DELETE",
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: "follow",
                        };

                        // console.log("data send", urlencoded);

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/withdrawalrequests/${coderetrait}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setDeleting(false);
                                showSuccesMessage(textes.fr.dmretratideletedlabel);
                                setEditedstate(false);
                                navigate(-1);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete", data);
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setDeleting(false);
                            }
                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setDeleting(false);
                        });
                    },
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: "#ff0000",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    },
                },
            ],
            closeOnClickOutside: false,
        });
    };

    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editdmretratilabel,
            message: textes.fr.editdmretratilabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: "#01203f",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        if (nom) urlencoded.append("nom", nom);
                        if (nom) urlencoded.append("nom", nom);
                        if (montant) urlencoded.append("montant", montant);
                        if (numtel) urlencoded.append("numtel", numtel);
                        if (motif) urlencoded.append("motif", motif);
                        urlencoded.append("coderevendeur", revendeur["value"]);
                        urlencoded.append("etatdef", etatdef);
                        urlencoded.append("defaut", false);
                        urlencoded.append("edit", true);
                        // console.log("data send", urlencoded)

                        var requestOptions = {
                            method: 'PUT',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/withdrawalrequests/${coderetrait}`, requestOptions).then((response) => {
                            if (response?.status === 204) {
                                showSuccesMessage(textes.fr.dmretratiupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setFetching(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setFetching(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setFetching(false);
                        });
                    },
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: "#ff0000",
                        color: "#ffffff",
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    },
                },
            ],
            closeOnClickOutside: false,
        });
    };

    const handleDone = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editdmretratilabel,
            message: textes.fr.editdmretratilabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setdoing(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "3");
                        urlencoded.append("etatdef", "Effectué");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/withdrawalrequests/${coderetrait}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.dmretratiupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setdoing(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setdoing(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setdoing(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setdoing(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleStart = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editdmretratilabel,
            message: textes.fr.editdmretratilabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setstarting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "2");
                        urlencoded.append("etatdef", "Validée");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/withdrawalrequests/${coderetrait}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.dmretratiupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setstarting(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setstarting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setstarting(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setstarting(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleCancel = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editdmretratilabel,
            message: textes.fr.editdmretratilabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setcancelling(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("etat", "5");
                        urlencoded.append("etatdef", "Annulée");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/withdrawalrequests/${coderetrait}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.dmretratiupdatedlabel);
                                setEditedstate(false);
                                setvalidstate(false);
                                getElement();
                                setcancelling(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setcancelling(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setcancelling(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setcancelling(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleReject = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.editdmretratilabel,
            message: textes.fr.editdmretratilabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setrejecting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.app.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("motif", motif);
                        urlencoded.append("etat", "4");
                        urlencoded.append("etatdef", "Rejetée");

                        // console.log("data send", datas)

                        var requestOptions = {
                            method: 'PATCH',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/withdrawalrequests/${coderetrait}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                showSuccesMessage(textes.fr.dmretratiupdatedlabel);
                                setEditedstate(false);
                                setvalidstate(false);
                                getElement();
                                setrejecting(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setrejecting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setrejecting(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setrejecting(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }


    // affichage
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && (
                    <div
                        className="col-md-12"
                        style={{
                            paddingTop: 8,
                            borderTop: "1px solid #ddd",
                            borderRadius: 8,
                        }}
                    >
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card shadow mb-4">
                                    <div className="card-header py-3">
                                        <button
                                            onClick={() => navigate(-1)}
                                            data-toggle="tooltip"
                                            title={textes.fr.back}
                                            data-placement="left"
                                            className="btn-shadow ml-3 btn btn-dark btn-sm float-right"
                                        >
                                            <i className="fa fa-reply"></i>{" "}
                                            <span>{textes.fr.back}</span>
                                        </button>
                                        {(user?.isFullAction || user?.isModifierDemanderetrait) && !editedstate && etat === 1 && (
                                            <button
                                                onClick={() => setEditedstate(true)}
                                                title={textes.fr.editdmretratilabel}
                                                className="btn-shadow ml-3 btn btn-success btn-sm float-right"
                                            >
                                                <i className="fa fa-edit mr-1"></i>{" "}
                                                <span>{textes.fr.edit}</span>
                                            </button>
                                        )}
                                        {(user?.isFullAction || user?.isSupprimerDemanderetrait) && !editedstate && etat === 1 && (
                                            <button
                                                onClick={handleDelete}
                                                title={textes.fr.deletedmretratilabel}
                                                className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                            >
                                                <i className="fa fa-trash mr-1"></i>{" "}
                                                <span>{textes.fr.delete}</span>{" "}
                                                {deleting && (
                                                    <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />
                                                )}
                                            </button>
                                        )}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isRejeterDemanderetrait) && !editedstate && etat === 1 && <button
                                            onClick={() => {
                                                setvalidstate(true);
                                                setEditedstate(true);
                                            }}
                                            title="Rejeter la demande de retrait"
                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                            <i className="fa fa-arrow-down mr-1"></i> <span>Rejeter</span>
                                        </button>}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isValiderDemanderetrait) && !editedstate && etat === 1 && <button onClick={handleStart}
                                            title="Valider la demande de retrait"
                                            className="btn-shadow ml-3 btn btn-info btn-sm float-right">
                                            <i className="fa fa-check-circle mr-1"></i> <span>Valider</span>  {starting && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        {(user?.isFullAction || user?.isAnnulerDemanderetrait) && !editedstate && etat === 1 && <button onClick={handleCancel}
                                            title="Annuler le site"
                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                            <i className="fa fa-reply mr-1"></i> <span>Annuler</span>  {cancelling && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        {(user?.isFullAction || user?.isAdminAction || user?.isConfirmerretrait) && !editedstate && etat === 2 && <button onClick={handleDone}
                                            title="Déclarer la demande de retrait effectuée"
                                            className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                            <i className="fa fa-arrow-up mr-1"></i> <span>Effectuer</span>  {doing && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                        </button>}
                                        <h5 className="m-0 ">
                                            {textes.fr.siteinfoslabel}
                                        </h5>
                                    </div>
                                    <div className="card-body">
                                        {!validstate && <form style={{ width: "100%" }} className="mb-3" onSubmit={handleSubmitEdit}>
                                            {/* ={editedstate ? false : true} */}
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <div className="row">
                                                        {(user?.isFullAction || user?.isAdminAction) && <div className="col-md-12 mb-3">
                                                            <label htmlFor="revendeur" className="mb-1">
                                                                {textes.fr.revendeurlabel}
                                                            </label>
                                                            <Select
                                                                id="revendeur"
                                                                name="revendeur"
                                                                placeholder={textes.fr.selectlabel}
                                                                options={revendeursList}
                                                                value={revendeur}
                                                                onChange={(selected) => {
                                                                    setrevendeur(selected);
                                                                }}
                                                                isClearable
                                                                isDisabled
                                                            />
                                                        </div>}
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="numtel" className="mb-1">
                                                                Numéro de téléphone
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="numtel"><Phone /></span>
                                                                <input
                                                                    type="tel"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={numtel}
                                                                    onChange={(e) =>
                                                                        setnumtel(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="nom" className="mb-1">
                                                                Nom associé
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="nom"
                                                                >
                                                                    <Person />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={nom}
                                                                    onChange={(e) =>
                                                                        setnom(e.target.value)
                                                                    }
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12 mb-3">
                                                            <label htmlFor="montant" className="mb-1">
                                                                Montant à retirer
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="montant"><Cash /></span>
                                                                <input
                                                                    type="number"
                                                                    min={100}
                                                                    max={montantmax}
                                                                    className="form-control"
                                                                    placeholder={textes.fr.entervaluelabel}
                                                                    value={montant}
                                                                    onChange={(e) => { setmontant(e.target.value) }}
                                                                    disabled={editedstate ? false : true}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="etat" className="mb-1">Etat</label>
                                                            <div className="input-group flex-nowrap">
                                                                <input
                                                                    readOnly
                                                                    type="text"
                                                                    className={`form-control 
                                                                        ${etat === 1 ? "text-white bg-warning" :
                                                                            etat === 2 ? "text-white bg-info" :
                                                                                etat === 3 ? "text-white bg-success" :
                                                                                (etat === 4 || etat === 5) ? "text-white bg-danger" :
                                                                                    ""
                                                                        }`}
                                                                    id="etat"
                                                                    value={etatdef}
                                                                    onChange={(e) => setEtat(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label htmlFor="dateadd" className="mb-1">
                                                                {textes.fr.addeddatelabel}
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span className="input-group-text" id="dateadd">
                                                                    <Calendar2 />
                                                                </span>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={datecrea}
                                                                    onChange={(e) => setDatecrea(e.target.value)}
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {editedstate && (
                                                    <div className="col-md-12 mt-2">
                                                        <button
                                                            type="submit"
                                                            title={textes.fr.editdmretratilabel}
                                                            className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                        >
                                                            <i className="fa fa-check mr-2"></i>
                                                            <span>Modifier</span>{" "}
                                                            {fetching && (
                                                                <Spinner
                                                                    as="span"
                                                                    animation="border"
                                                                    size="sm"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                />
                                                            )}
                                                        </button>
                                                        <button
                                                            onClick={() => setEditedstate(false)}
                                                            title={textes.fr.cancel}
                                                            className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                        >
                                                            <i className="fa fa-reply mr-1"></i>{" "}
                                                            <span>{textes.fr.cancel}</span>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </form>}
                                        {validstate && <form style={{ width: "100%" }} className="mb-3" onSubmit={handleReject}>
                                            {/* ={editedstate ? false : true} */}
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                            <label htmlFor="motif" className="mb-1">
                                                                Motif
                                                            </label>
                                                            <div className="input-group flex-nowrap">
                                                                <span
                                                                    className="input-group-text"
                                                                    id="motif"
                                                                >
                                                                    <TextParagraph />
                                                                </span>
                                                                <textarea
                                                                    className="form-control"
                                                                    placeholder={
                                                                        textes.fr.descriptionlabel
                                                                    }
                                                                    value={motif}
                                                                    style={{ height: 154 }}
                                                                    onChange={(e) =>
                                                                        setmotif(e.target.value)
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 mt-2">
                                                    <button
                                                        type="submit"
                                                        title={textes.fr.editdmretratilabel}
                                                        className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                        disabled={motif ? false : true}
                                                    >
                                                        <i className="fa fa-check mr-2"></i>
                                                        <span>Valider</span>{" "}
                                                        {rejecting && (
                                                            <Spinner
                                                                as="span"
                                                                animation="border"
                                                                size="sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            />
                                                        )}
                                                    </button>
                                                    <button
                                                        onClick={() => { setEditedstate(false); setvalidstate(false) }}
                                                        title={textes.fr.cancel}
                                                        className="btn-shadow ml-3 btn btn-danger btn-sm float-right"
                                                    >
                                                        <i className="fa fa-reply mr-1"></i>{" "}
                                                        <span>{textes.fr.cancel}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
